<template>
  <el-dialog title="重置密码" v-model="updateDialog" width="600px"  v-show="updateDialog" append-to-body>
    <el-form  ref="updateElForm" :model="addRow" :rules="rules" label-width="120px" >
      <div class="hidden-input">
        <input type="text" class="form-control">
        <input type="password" class="form-control">
      </div>
      <el-form-item class="row" label="新密码" prop="newPassword">
        <el-input  class="w300" type="password" v-model="addRow.newPassword"  auto-complete="new-password" placeholder="请输入新密码"  ></el-input>
        <br>
      </el-form-item>
      <el-form-item class="row" label="确认新密码" prop="newPasswordCheck">
        <el-input  class="w300" type="password" v-model="addRow.newPasswordCheck"  auto-complete="new-password"  placeholder="请再次输入新密码"  ></el-input>
      </el-form-item>
    </el-form>
    <div v-show="false">
      <button id="updateEle"> </button>
    </div>
    <span slot="footer" class="flex-e">
        <el-button @click="cancel()">取 消</el-button>
        <el-button  @click="updatePassword()">确 定</el-button>
      </span>
  </el-dialog>
</template>

<script>
export default {
  name: "reset-shop-pass",
  computed: {
    user() {
      return this.$store.state.user;
    }
  },
  data() {
    let validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        if (value.length < 6) {
          callback(new Error('新密码长度必须大于6'));
        }
        if (value.length > 16) {
          callback(new Error('新密码长度必须小于16'));
        }
        if (this.addRow.newPasswordCheck !== '') {
          this.$refs['updateElForm'].validateField('newPasswordCheck');
        }
        callback();
      }
    };
    let validatePass3 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.addRow.newPassword) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      pass: /(?!.*[\u4E00-\u9FA5\s])(?!^[a-zA-Z]+$)(?!^[\d]+$)(?!^[^a-zA-Z\d]+$)^.{6,16}$/,
      updateDialog: false,
      addRow: { newPassword: '',newPasswordCheck:''},
      rules: {
        newPassword: [
          {validator: validatePass2, trigger: 'blur'}
        ],
        newPasswordCheck: [
          {validator: validatePass3, trigger: 'blur'}
        ],
      },
      shopId:"",
    }
  },
  mixins: [tableBase],
  methods: {
    updatePassword() {
      this.$refs['updateElForm'].validate((valid) => {
        if (valid) {
          this.simplePost("/api/mgr/business/shop/resetPassword",{id:this.shopId,password:this.addRow.newPassword},()=>{
            this.message("修改成功");
            this.cancel();
          })
        }
      });
    },
    openDialog(id) {
      this.shopId = id;
      this.updateDialog = true;
    },
    cancel(){
      this.updateDialog =false;
    },
  },
  mounted() {

  }
}
</script>


<style lang="less" scoped>
.send-but{
  margin-left: 8px;
}
.flex-e{
  padding-bottom: 20px;
  margin-right: 10px;
}
</style>
